<template>
  <div>
    <!-- nav -->
    <versionNav></versionNav>
    <!-- 目前模块为background -->
    <section class="topBg">
      <div class="inner">
        <ul class="topBg_nav">
          <li
            v-for="(item,index) in navList"
            :key="index"
            @click="downDown(item.id)"
          >
            <img
              src="../assets/img/dian_03.png"
              alt=""
              srcset=""
            >
            <p>{{item.text}}</p>
          </li>
        </ul>
        <p class="taskText">{{taskText}}</p>
        <div class="linkBox clearfix">
          <div class="downloadGame"><a href="http://qqsm.zygames.com/t1/download.html">游戏下载</a></div>
          <div class="goHome"><a href="http://qqsm.zygames.com/t2/main.html">官网首页</a></div>
        </div>
      </div>
    </section>
    
    <!-- 新武器 -->
    <section
      class="xwq"
      id="xwq"
      >
      <!-- 新武器轮播 -->
      <!-- <div class="inner">
        <xwq-tab-play></xwq-tab-play> 
      </div> -->
    </section>

    <!-- 新配方 -->
    <!-- <section
    
      class="xpf"
      id="xpf"
    >
    </section> -->
    
    <!-- 新地图 -->
    <section
      class="xdt"
      id="xdt"
    >
      <div class="inner">
        <!-- 新地图视频 -->
        <!-- <videoPlayer class="myvideo"></videoPlayer> -->
        <!-- <video-player></video-player> -->
      </div>
    </section>

    <!-- 新时装 -->
    <section
      class="xsz"
      id="xsz"
    ></section>

    <!-- 新插件/装置 -->
   <!-- <section
      class="xcj"
      id="xcj"
    ></section> -->

    <!-- 靶场 -->
    <versionBc></versionBc>
    <!-- 周免道具 -->
    <freeProps id="freeProps"></freeProps>
  </div>
</template>
<script>
import { mapGetters } from "vuex"
import versionBc from "../components/qqsmVersion_bc.vue";
import freeProps from "../components/freeProps.vue";
import xwqTabPlay from "../components/xwqTabPlay.vue";
import videoPlayer from "../components/videoPlayer.vue";
export default {
  name: "Home",
  data() {
    return {
      navList: [
        { text: "新武器   New Weapons", id: "xwq" },
        // { text: "武器配方   New Weapons", id: "xpf" },
        { text: "新地图   New Maps", id: "xdt" },
        { text: "新时装   New Clothes", id: "xsz" },
        { text: "免费福利   New Free", id: "freeProps" }
      ]
    };
  },
  created(){
    console.log('index_created')
  },
  mounted() {
    // this.cons();
    console.log('index_mounted')
  },
  computed:{
    ...mapGetters(['taskText'])
  },
  components: {
    versionBc, //靶场
    freeProps, //免费武器
    xwqTabPlay, //新武器轮播
    videoPlayer
  },
  methods: {
    downDown(selector) {
      var anchor = this.$el.querySelector("#" + selector);
      anchor.scrollIntoView({ behavior: "smooth", block: "start" });
    },
    player() {
      this.$layer.open({
        type: 1,
        title: false,
        closeBtn: 1, //不显示关闭按钮
        shade: [0],
        area: ["600px", ""],
        skin: "blackBg",
        anim: 1,
        content: ` 
        <video
          class="myvideo"
          poster="../../static/myvideoBg.jpg"
          src="http://cdn1.zygames.com/qqsm/video/Mars_cutscene_2.webm"
          width="560"
          height="320"
          preload
          controls
        ></video>
      `
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.inner {
  width: 1200px;
  margin: 0 auto;
  position: relative;
  padding-top: 1px;
}
.topBg {
  background: url("../assets/img/bg1.jpg") no-repeat top center;
  height: 1065px;
  position: relative;
  min-width: 1200px;
  .topBg_nav {
    width: 480px;
    height: 76px;
    /* margin-top: 480px; */
    position: absolute;
    top: 596px;
    left: 381px;
    text-align: left;
    li {
      width: 235px;
      height: 37px;
      float: left;
      color: #fff;
      cursor: pointer;
      &:hover {
        color: #fbbe10; //red;
      }
      img {
        padding: 0 15px;
      }
      p {
        font-size: 16px;
        line-height: 37px;
        display: inline-block;
      }
    }
  }
  .taskText {
    font-size: 16px;
    color: #fff;
    text-align: center;
    line-height: 60px;
    margin-top: 699px;
  }
  .linkBox {
    width: 745px;
    margin: 70px auto 0;
    div {
      float: left;
      width: 298px;
      height: 85px;
      font-weight: bold;
      text-align: center;
      background-color: #c21616; //#274479;
      font-size: 30px;
      padding: 2px;
      a {
        transition: 0.4s all;
        display: inline-block;
        width: 294px;
        height: 81px;
        line-height: 80px;

        color: #fff;
        border: 2px solid #c21616; //#274479; //
        &:hover {
          border: 2px solid #ff3232; //#7f899c; //
        }
      }
    }
    div.downloadGame {
      background-color: #fbbe10;
      margin-right: 140px;
      a {
        color: #160c04;
        border: 2px solid #fbbe10;

        &:hover {
          border: 2px solid #ffff24;
        }
      }
    }
  }
}
.xwq {
  background: url("../assets/img/xwq.jpg") no-repeat top center;
  height: 885px;
  position: relative;
  min-width: 1200px;
}
.xpf {
  background: url("../assets/img/xpf.jpg") no-repeat top center;
  height: 885px;
  position: relative;
  min-width: 1200px;
}
.xdt {
  background: url("../assets/img/xdt.jpg") no-repeat top center;
  height: 899px;
  position: relative;
  min-width: 1200px;
}
.xsz {
  background: url("../assets/img/xsz.jpg") no-repeat top center;
  height: 899px;
  position: relative;
  min-width: 1200px;
}
.xcj {
  background: url("../assets/img/xcj.jpg") no-repeat top center;
  height: 921px;
  position: relative;
  min-width: 1200px;
}

/**/
.myvideo {
  margin: 289px auto;
  width: 79px;
  height: 69px;
}
</style>

























// WEBPACK FOOTER //
// src/pages/index.vue